import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';
import { LeadFormProps } from '@telialt/common-lead/src/model';

export const usePlanOrderLeadModalControls = () => {
    const { isModalOpen, closeModal, openModal, modalData } = useBrowserModalControls<LeadFormProps>('plan-order-lead');

    return {
        isPlanOrderLeadModalOpen: isModalOpen,
        openPlanOrderLeadModal: openModal,
        closePlanOrderLeadModal: closeModal,
        leadModalData: modalData,
    };
};
